import React, { useCallback } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { makeStyles } from "tss-react/mui";

import Box from "@mui/material/Box";

import List from "./List";
import Tile from "./Tile";
import ComponentSuspense from "../../../../Common/ComponentSuspense";

import { navDatasets } from "../../../../kmk/AppData";
import { DATASOURCE_VIEWS } from "../data";
import Mapping from "../../MappingView";

const ERDiagram = React.lazy(() => import("./ERDiagram"));

const useStyles = makeStyles()((theme) => ({
  PanelContainer: {
    marginTop: "25px",
    padding: "0px 25px",
    display: "flex",
    flexDirection: "column",
    maxWidth: "100%",
    minWidth: "100%",
    width: "100%",
    minHeight: "250px",
    marginLeft: "inherit",
  },
}));

function DataSources({
  view,
  loading,
  sources,
  diagramSources,
  mappedObjects,
  selectedTags,
  dataLoaded,
  handleDeleteClick,
}) {
  const { Workspace_id } = useParams();
  const { classes } = useStyles();
  const navigate = useNavigate();

  const handleEditClick = useCallback(
    (id) => {
      navigate(`/my-workspaces/${Workspace_id}/${navDatasets.link}/${id}`);
    },
    [Workspace_id, navigate]
  );

  const navigateToDashboard = useCallback(
    (state) => {
      navigate(`/my-workspaces/${Workspace_id}/${navDatasets.link}/statistics`, {
        state,
      });
    },
    [Workspace_id, navigate]
  );

  switch (view) {
    case DATASOURCE_VIEWS["List View"]:
      return (
        <Box className={classes.PanelContainer}>
          <List
            loading={loading}
            sources={sources}
            selectedTags={selectedTags || []}
            dataLoaded={dataLoaded || false}
            handleEditClick={handleEditClick}
            navigateToDashboard={navigateToDashboard}
            handleDeleteClick={handleDeleteClick}
          />
        </Box>
      );
    case DATASOURCE_VIEWS["Tile View"]:
      return (
        <Box className={classes.PanelContainer} sx={{ overflowY: "auto" }}>
          <Tile loading={loading} sources={sources} navigateToDashboard={navigateToDashboard} />
        </Box>
      );
    case DATASOURCE_VIEWS["ER Diagram"]:
      return !loading && diagramSources.length ? (
        <ComponentSuspense>
          <ERDiagram sources={diagramSources} />
        </ComponentSuspense>
      ) : (
        <></>
      );
    case DATASOURCE_VIEWS.Mapping:
      return !loading && mappedObjects !== false ? <Mapping mappedObjects={mappedObjects} /> : <></>;
    default:
      return <List loading={loading} />;
  }
}

export default DataSources;
